import Layout from "../components/layout";
import ComingSoon from "../components/comingSoon";

const Files = () => {

  return (
    <Layout>
      <ComingSoon/>
    </Layout>
  );
};

export default Files;
